import React from 'react'
import { useTranslation } from 'react-i18next'
import { light } from '../../../Theme/themes'

// Shown above the header instead of the promo bar (PromoCodes.tsx) while the wholesale mode is on. Same size and
// placement as the promo bar: `data-promo-bar` lets HeaderBase.tsx account for its height the same way.
const WholesaleModeBar = () => {
  const { t } = useTranslation()
  return (
    // The extra 20px at the bottom sits under the header's rounded top corners (_header.scss).
    <div data-promo-bar className='relative -mb-20 pb-20' style={{ backgroundColor: light.warning, zIndex: 30 }}>
      <div className='flex items-center justify-center h-[45px] px-10 text-13 sm:text-base font-semibold text-white text-center'>
        {t('header.wholesaleModeBar', 'You are in Wholesale Mode')}
      </div>
    </div>
  )
}

export default React.memo(WholesaleModeBar)
